import { useFragment } from 'react-relay';

import type {
	preloadAutohighlightsQuery_query$data,
	preloadAutohighlightsQuery_query$key,
} from './__generated__/preloadAutohighlightsQuery_query.graphql.ts';
import { preloadAutohighlightsQueryFragment } from './preloadAutohighlights.ts';

export const useAutohighlightsQueryFragment = (
	fragmentRef: preloadAutohighlightsQuery_query$key | null | undefined,
): preloadAutohighlightsQuery_query$data | null | undefined =>
	useFragment(preloadAutohighlightsQueryFragment, fragmentRef ?? null);
